"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CheckIcon = function (props) {
    return (react_1.default.createElement("svg", __assign({ ref: props.iconref, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" }, props),
        react_1.default.createElement("path", { d: "M20 6.5L9 17.5L4 12.5", stroke: "green", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.default = CheckIcon;
